import ShopPayButton from "@/components/ShopPayButton";
import RestockForm from "@/components/RestockForm";
import TrustLine from "@/components/TrustLine";
import { shipsSameDay } from "@/lib/products";
import { TRUST_LINE_MADE_TO_ORDER, TRUST_LINE_IN_STOCK } from "@/lib/site";

// Under Add to Cart: Shop Pay (or the restock form when sold out), then the trust line.
export default function PdpBuyExtras({ product, variant, quantity, selectedSize, unavailable }) {
  const needsSize = product.sizes?.length > 0 && !selectedSize;
  return (
    <div data-testid="pdp-buy-extras">
      {unavailable ? (
        <RestockForm handle={product.id} size={selectedSize} />
      ) : needsSize ? (
        <p data-testid="shop-pay-hint" className="mt-3 text-[11px] text-[#8A8A8A]">Pick a size to check out with Shop Pay.</p>
      ) : (
        <ShopPayButton variantId={variant?.id} quantity={quantity} />
      )}
      <TrustLine className="mt-4" text={shipsSameDay(product) ? TRUST_LINE_IN_STOCK : TRUST_LINE_MADE_TO_ORDER} />
    </div>
  );
}
